import UserAvatar from "@/components/shared/UserAvatar";
import { MemberRole } from "@/server/types/member";
import { OA_BOT_USERNAME } from "@/config/constants";
import ChatMemberMenu from "./ChatMemberMenu";
import { useTranslation } from "react-i18next";

type Props = {
  username: string;
  role: MemberRole;
  isAuth: boolean;
};

export default function ChatMember({ username, role, isAuth }: Props) {
  const { t } = useTranslation();

  // The Architect bot is a first-class NON-HUMAN participant, not a user who
  // happens to hold a role. After its creator deletes their account the bot
  // becomes the chat's Owner (BE succession) — never render that as
  // "<hub-id> · Owner" (the raw username is a deployment id like `theoa`),
  // and never offer the per-member menu: re-roling or removing the bot from
  // its own chat must not be possible from this UI.
  const isArchitectBot = username === OA_BOT_USERNAME;

  return (
    <div className="flex items-center justify-start gap-3 px-4 py-2 align-middle">
      <UserAvatar username={username} className="size-8" />

      <div>
        <h3 className="truncate text-base">
          {isArchitectBot ? t("architectMember") : username}{" "}
        </h3>
        {!isArchitectBot && role === MemberRole.OWNER && (
          <h5 className="text-xs leading-none tracking-wider text-secondary">
            {t("ownerRole")}
          </h5>
        )}
        {!isArchitectBot && role === MemberRole.ADMIN && (
          <h5 className="text-xs leading-none tracking-wider text-foreground/50">
            {t("adminRole")}
          </h5>
        )}
        {!isArchitectBot && role === MemberRole.MODERATOR && (
          <h5 className="text-xs leading-none tracking-wider text-foreground/50">
            {t("moderatorRole")}
          </h5>
        )}
      </div>
      {!isAuth && !isArchitectBot && (
        <ChatMemberMenu username={username} role={role} />
      )}
    </div>
  );
}
